import React from "react";
import SEO from "../components/Seo/Seo";
import SideNav from "../components/GeneralComponents/SideNav";
import Navbar from "../components/GeneralComponents/Navbar";

const PrivacyPolicy = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4">
      <SEO title="Privacy Policy" />
      <SideNav className="!static hidden md:block" />
      <div className="col-span-1 lg:col-span-3">
        <Navbar />
        <div className="max-w-prose mx-auto p-4">
          <h2 className="text-2xl font-semibold mb-4">
            Privacy Policy for Paywater App and Website
          </h2>
          <p>
            <strong>Effective Date:</strong> 19th October, 2023
          </p>
          <p className="mt-4">
            Welcome to Paywater! This Privacy Policy describes how Paywater ("
            <span className="font-semibold">we</span>," "
            <span className="font-semibold">our</span>," or "
            <span className="font-semibold">us</span>") collects, uses, and
            shares information about you when you use our mobile app (the "
            <span className="font-semibold">App</span>") and our website (the "
            <span className="font-semibold">Website</span>"). We take your
            privacy seriously, and this policy is designed to help you
            understand what information we collect and how we protect it.
          </p>
          <p>
            By using the App or the Website, you consent to the practices
            described in this Privacy Policy.
          </p>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">
              Information We Collect
            </h3>
            <ol className="list-decimal list-inside ml-4 flex flex-col space-y-3">
              <li>
                <span className="font-bold text-underline">
                  Registration Information:
                </span>{" "}
                When you sign up for an account on the Paywater App or Website,
                we may collect the following information:
                <ul className="list-disc list-inside ml-4">
                  <li>Your name</li>
                  <li>Home type (e.g., residential, commercial)</li>
                  <li>Meter number</li>
                  <li>Family size</li>
                  <li>Number of males in your family</li>
                  <li>Number of females in your family</li>
                </ul>
              </li>
              <li>
                <span className="font-bold text-underline">
                  Water Usage Information:
                </span>{" "}
                We collect data related to your water usage, such as the volume
                of water purchased and meter readings. This information is
                necessary to provide the water meter services you've requested.
              </li>
              <li>
                <span className="font-bold text-underline">
                  Device Information:
                </span>{" "}
                We may collect information about your mobile device and
                computer, including device type, operating system, and unique
                device identifiers. This data helps us optimize and improve our
                App and Website's performance.
              </li>
              <li>
                <span className="font-bold text-underline">
                  Location Information:
                </span>{" "}
                We may collect your precise or approximate location information
                when you use the App or the Website to ensure accurate water
                usage tracking.
              </li>
            </ol>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">
              How We Use Your Information
            </h3>
            <ul className="list-disc list-inside ml-4">
              <li>
                Providing you with access to the Paywater water meter services.
              </li>
              <li>Processing transactions and purchases of water credits.</li>
              <li>
                Personalizing and improving your experience on the App and
                Website.
              </li>
              <li>Sending you important updates, alerts, and notifications.</li>
              <li>
                Analyzing data to improve our services, troubleshoot issues, and
                enhance security.
              </li>
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">Information Sharing</h3>
            <ul className="list-disc list-inside ml-4">
              <li>
                We do not sell your personal information to third parties.
                However, we may share your information with:
              </li>
              <li>
                Service providers and partners who assist us in delivering the
                services you've requested.
              </li>
              <li>
                Government water corporations or relevant authorities, as
                required by law or regulation.
              </li>
              <li>
                When you consent to the sharing of your information with third
                parties.
              </li>
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">Data Security</h3>
            <p>
              We take data security seriously and implement reasonable security
              measures to protect your information. However, please note that no
              method of data transmission over the internet or electronic
              storage is completely secure.
            </p>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">Your Choices</h3>
            <ul className="list-disc list-inside ml-4">
              <li>Update your account details.</li>
              <li>Opt out of marketing communications.</li>
              <li>Delete your account.</li>
            </ul>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">
              Changes to This Privacy Policy
            </h3>
            <p>
              We may update this Privacy Policy to reflect changes in our
              practices or for other operational, legal, or regulatory reasons.
              We will provide notice of such changes, and we encourage you to
              review the Privacy Policy periodically.
            </p>
          </div>

          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-2">Contact Us</h3>
            <p>
              If you have any questions or concerns about this Privacy Policy,
              please contact us at{" "}
              <a
                href="mailto:info@hydronamics.com.ng"
                className="text-pw-blue-500 hover:underline"
              >
                info@hydronamics.com.ng
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
